import { useState } from 'react';
import dayjs from 'dayjs';

const STORAGE_KEY = 'swarmsHistory_searchParams';

const getInitialSearchParams = () => {
  const storedSearchParams = sessionStorage.getItem(STORAGE_KEY);
  const params = storedSearchParams ? JSON.parse(storedSearchParams) : {
    eventName: '',
    venueName: '',
    selectedDate: dayjs(),
    PageNo: 1,
    RecordsLimit: 50,
    OrderBy: 'EventName',
    Descending: false,
  };
  
  // Convert selectedDate back to dayjs object if it exists
  if (params.selectedDate) {
    params.selectedDate = dayjs(params.selectedDate);
  }
  
  return params;
};

export const createQueryParams = (searchParams) => {
  const requestQuery = {};

  // Add pagination parameters
  requestQuery.PageNo = searchParams.PageNo || 1;
  requestQuery.RecordsLimit = searchParams.RecordsLimit || 50;
  requestQuery.OrderBy = searchParams.OrderBy || 'EventName';
  requestQuery.Descending = searchParams.Descending || false;

  // Add other search parameters
  if (searchParams.eventName) {
    requestQuery.eventName = searchParams.eventName;
  }

  if (searchParams.venueName) {
    requestQuery.venueName = searchParams.venueName;
  }

  if (searchParams.selectedDate) {
    const selectedDate = dayjs(searchParams.selectedDate);
    requestQuery.StoppedOn = [
      selectedDate.startOf('day').toISOString(),
      selectedDate.endOf('day').toISOString()
    ];
  }

  delete requestQuery.selectedDate;
  
  return requestQuery;
};

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useState(getInitialSearchParams());

  const updateSearchParams = (newParams) => {
    const updatedParams = { ...searchParams, ...newParams };
    setSearchParams(updatedParams);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updatedParams));
  };

  return {
    searchParams,
    updateSearchParams,
    createQueryParams: (params) => createQueryParams(params || searchParams)
  };
};
